import {
    type TextStyle,
    type ViewStyle,
    StyleSheet
} from "react-native";
import {
    getTypeColors
} from "../../../../helpers/theme/typeColors";
import type {
    Mutable
} from "../../../../types";
import type {
    SidebarBadgeType,
    SidebarMeasures,
    SidebarSize
} from "../../type";

export const SIDEBAR_BADGE_VARIANT: keyof NCoreUIKit.Typography = "labelSmallSize";

export const SIDEBAR_BADGE_TITLE_STYLE: TextStyle = {
    fontVariant: [
        "tabular-nums"
    ]
};

const stylesheet = StyleSheet.create({
    overlay: {
        justifyContent: "center",
        pointerEvents: "none",
        position: "absolute",
        bottom: 0,
        top: 0
    },
    corner: {
        justifyContent: "center",
        pointerEvents: "none",
        position: "absolute",
        alignItems: "center",
        borderStyle: "solid"
    },
    inert: {
        pointerEvents: "none"
    },
    plain: {
        flexShrink: 0
    },
    container: {
        flexShrink: 0
    }
});

export const useStyles = ({
    isActionVisible,
    isCollapsed,
    typography,
    hasAction,
    iconSizes,
    measures,
    radiuses,
    borders,
    variant,
    colors,
    spaces,
    type,
    size
}: {
    radiuses: NCoreUIKit.ActivePalette["radiuses"];
    colors: NCoreUIKit.ActivePalette["colors"];
    spaces: NCoreUIKit.ActivePalette["spaces"];
    variant: "floating" | "sidebar" | "inset";
    typography: NCoreUIKit.Typography;
    iconSizes: NCoreUIKit.IconSizes;
    borders: NCoreUIKit.Borders;
    measures: SidebarMeasures;
    isActionVisible: boolean;
    type: SidebarBadgeType;
    isCollapsed: boolean;
    hasAction: boolean;
    size: SidebarSize;
}) => {
    const inset = (measures.square - iconSizes[size]) / 2;

    const lineHeight = typography.labelSmallSize.lineHeight;

    const cornerHeight = lineHeight + borders.subtract * 2;

    const styles = {
        corner: {
            borderColor: colors.content.container[variant === "floating" ? "raised" : "mid"],
            start: inset + iconSizes[size] - cornerHeight / 2,
            paddingHorizontal: spaces.spacingXs,
            backgroundColor: getTypeColors({
                variant: "filled",
                colors,
                type
            }).containerColor,
            top: inset - cornerHeight / 2,
            borderWidth: borders.subtract,
            borderRadius: radiuses.full,
            minWidth: cornerHeight,
            height: cornerHeight
        } as Mutable<ViewStyle>,
        overlay: {
            opacity: isActionVisible ? 0 : 1,
            end: inset
        } as Mutable<ViewStyle>
    };

    return {
        ...styles,
        isOverlay: hasAction && !isCollapsed,
        cornerTitleColor: getTypeColors({
            variant: "filled",
            colors,
            type
        }).titleColor
    };
};
export default stylesheet;
